<section class="content">
  <h2>DATEV-Integration</h2>

  @if (datevService.isLoading()) {
    <div class="mt-xl">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Laden Daten...</p>
    </div>
  }

  @if (!datevService.isActivated()  && !datevService.isLoading()) {
    <app-set-client-form></app-set-client-form>
  }

  @if (datevService.isUser()  && !datevService.isLoading() && datevService.isActivated()) {
    <app-set-config-form></app-set-config-form>
  }

  <p class="d-flex jce aic mt-l">
  <span
    class="material-symbols-outlined mr-xs">{{ datevService.isActivated() ? 'check_circle' : 'error' }}</span>
    Aktuell ist die Datenübertragung für IDF {{userService.selectedIdf()}} an DATEV {{ datevService.isActivated()
    ? 'aktiv' : 'nicht aktiv' }}.
  </p>
</section>
